The legacy SEEK advertiser ID.

This is a numeric identifier that was used by the previous version of Apply with SEEK.
